export interface Icons {
  addButton?: {
    header?: string;
    floating?: string;
  };
  deleteButton?: string;
  saveButton?: string;
  copyButton?: string;
  importButton?: string;
}
